import { i18n } from '../translate/i18n';

const locationError = () => {
  if (navigator.permissions) {
    navigator.permissions.query({ name: 'geolocation' }).then(res => {
      if (res.state === 'denied') {
        alert(i18n.t('locationError.alert'))
        return false;
      }
    })
  } else {
    alert(i18n.t('locationError.else'))
    return false;
  }
}

const getLocation = (locationSuccess) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(locationSuccess, locationError);
  } else {
    alert(i18n.t('locationError.else1'))
    return false
  }
}

export default getLocation;
